// extracted by mini-css-extract-plugin
export default {"MainBody":"mainLayout_MainBody__mkDSI"};